import React, { useEffect, useState } from "react";
import styles from '../Form.module.css'
import PhoneInput from "../inputs/PhoneInput";
import { BsFillCheckCircleFill } from 'react-icons/bs';
import RadioSelect from "../inputs/RadioSelect";
import { FaPenFancy } from "react-icons/fa";
import { RiTestTubeFill } from "react-icons/ri";



function Step4({ formData, setFormData, setNextButtonState }) {


  useEffect(() => {
    setNextButtonState(formData.name !== ''
      &&
      formData.preferedLangage !== '' &&
      formData.usageTarget !== '')
  }, [formData]);



  return (

    <div>
      <div className={styles.header}>
        <h1>You're almost there</h1>
      </div>


      <div className={styles.subFormContainer}>

        <center>
          <p>Kindly note that your identity is completely anonymous on the website</p>

        </center>

        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.usageTarget === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              What do you mainly want help in?
            </div>
            <RadioSelect

              onChange={(data) =>
                setFormData({ ...formData, usageTarget: data })
              }

              value={formData.usageTarget}
              options={[
                { value: 'exam', component: <div>Exams Preperations<RiTestTubeFill /></div> },
                { value: 'homework', component: <div>homework<FaPenFancy /></div> },
                { value: 'both', component: <div>Both</div> },]}

              selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
              notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
            />
          </div>
        </div>



        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.preferedLangage === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              Favorite Langage for communicating on Questa?
            </div>
            <RadioSelect

              onChange={(data) =>
                setFormData({ ...formData, preferedLangage: data })
              }

              value={formData.preferedLangage}
              options={[{ value: 'ar', component: <div>Arabic</div> },
              { value: 'fr', component: <div>French</div> },
              { value: 'eng', component: <div>English</div> },]}

              selectedStyle={{ backgroundColor: "rgb(0, 123, 250)", color: 'white' }}
              notSelectedStyle={{ backgroundColor: "rgb(0, 123, 250,0.06)", color: "rgb(0, 123, 250)" }}
            />


          </div>
        </div>



        <div className={styles.singleFormInputContainer}>

          <div className={styles.checkedInput}
            style={{ color: formData.name === '' ? 'transparent' : 'rgb(0, 123, 250)' }}><BsFillCheckCircleFill /></div>
          <div className={styles.singleFormInput}>
            <div className={styles.singleInputTitle}>
              Enter a nickname
            </div>


            <input
              maxLength={30}
              type="text"
              placeholder="Name..."
              value={formData.name}
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
              }}
            />
          </div>
        </div>

      </div>
    </div>
  );
}

export default Step4;
